import {InputTypes, ValueTypes, IFieldDefinition, FieldViews} from 'app/interfaces';
import { Validators } from '@angular/forms';
import { toursFieldsMap } from './fields';
import { IDataContainerService } from 'app/interfaces/data-container.interface';

const fieldsMap: Map<string, IFieldDefinition> = new Map();

toursFieldsMap.forEach(function(value, key, map): void{
	value = Object.assign({}, value, { key: value.key });
	fieldsMap.set(key, value);
});

fieldsMap.set('parameters.use_incoming_prices', {
	key: 'parameters.use_incoming_prices',
	name: 'Usa Prezzi in ingresso',
	inputType: InputTypes.SELECT,
	valueType: ValueTypes.BOOLEAN,
	options: [
		{
			label: 'Si',
			value: true
		},
		{
			label: 'No',
			value: false
		}
	],
	optionSelected: false
});

fieldsMap.set('parameters.seller_id', {
	key: 'parameters.seller_id',
	name: 'Seller ID',
	inputType: InputTypes.TEXT,
	valueType: ValueTypes.STRING
});
fieldsMap.set('scenario', {
	key: 'scenario',
	name: '',
	inputType: InputTypes.HIDDEN,
	valueType: ValueTypes.STRING,
	fieldView: FieldViews.HIDDEN,
	formValidators: [ Validators.required ],
	defaultValue(dataContainerService: IDataContainerService) {
		return 'touroperators.xola';
	}
});

export {fieldsMap as xolaFieldsMap};
